import { SituationBanner } from "./situations/SituationBanner";

const SITUATIONS = [
    {
        id: "collecte",
        banner: "form",
        title: "Collecte de données personnelles",
        body: "Un formulaire, un fichier client ou un outil de prise de rendez-vous peut collecter des informations utiles, mais aussi des données excessives, mal expliquées ou conservées trop longtemps. L'enjeu est de vérifier ce qui est réellement nécessaire, ce qui doit être mieux présenté et ce qui peut être simplifié.",
    },
    {
        id: "pratiques",
        banner: "flows",
        title: "Pratiques numériques mal cadrées",
        body: "Messagerie, stockage, formulaires, plateformes, prestataires, solutions de paiement ou outils de suivi\u00a0: une activité s'appuie souvent sur plusieurs services sans vision nette de ce qui circule, de ce qui est stocké et de ce qui mérite d'être mieux maîtrisé.",
    },
    {
        id: "cadre",
        banner: "document",
        title: "Cadre de l'activité et documents à remettre au propre",
        body: "Conditions d'intervention, documents commerciaux, informations transmises aux clients, supports contractuels ou organisation de certaines relations peuvent rester flous, dispersés ou incomplets. Un accompagnement en amont permet de clarifier les points sensibles et de préparer une base plus solide pour l'activité.",
    },
    {
        id: "obligations",
        banner: "register",
        title: "Obligations courantes et situations à régulariser",
        body: "Certaines obligations sont souvent traitées trop tard ou de manière imprécise\u00a0: justificatifs à conserver, informations à formaliser, cohérence des pièces, relations avec les prestataires ou questions à incidence administrative, comptable ou fiscale. L'objectif est d'identifier ce qui doit être remis en ordre et, si nécessaire, préparé pour le bon interlocuteur.",
    },
];

function SituationCard({ situation }) {
    return (
        <article
            className="reveal flex flex-col bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-slate-300 transition-colors"
            data-testid={`situation-card-${situation.id}`}
        >
            <div
                className="aspect-[10/3] border-b border-slate-200"
                data-testid={`situation-banner-${situation.id}`}
            >
                <SituationBanner kind={situation.banner} />
            </div>
            <div className="p-6 md:p-7 lg:p-8 flex-1 flex flex-col">
                <h3
                    className="font-display text-lg lg:text-xl text-[#0B132B] font-medium tracking-tight mb-3"
                    data-testid={`situation-title-${situation.id}`}
                >
                    {situation.title}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed">
                    {situation.body}
                </p>
            </div>
        </article>
    );
}

export function Situations() {
    return (
        <section
            id="situations"
            className="border-b border-slate-200 bg-[#F9F9F8]"
            data-testid="situations-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12 md:mb-16">
                    <div className="lg:col-span-4">
                        <p className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                            04 — Cas
                        </p>
                        <h2
                            className="reveal font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                            data-testid="situations-title"
                        >
                            Situations traitées
                        </h2>
                    </div>
                    <div className="lg:col-span-7 lg:col-start-6">
                        <p
                            className="reveal text-base lg:text-lg text-slate-600 leading-relaxed max-w-2xl"
                            data-testid="situations-intro"
                        >
                            Quelques exemples de situations où un regard
                            extérieur permet de mieux encadrer les données
                            personnelles, corriger les pratiques numériques,
                            remettre certaines situations au propre et
                            sécuriser les obligations courantes.
                        </p>
                    </div>
                </div>

                <div
                    className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 lg:gap-8"
                    data-testid="situations-grid"
                >
                    {SITUATIONS.map((s) => (
                        <SituationCard key={s.id} situation={s} />
                    ))}
                </div>
            </div>
        </section>
    );
}
